import APIUrl from "../../APIUrl";
import axios from "axios";

export const GET_USER = "GET_USER";

export function getUserAction(user) {
  return { type: GET_USER, user: user };
}

export const getUser = function () {
  return function (dispatch) {
    return axios
      .get(APIUrl.getUser)
      .then(function (response) {
        dispatch(getUserAction(response.data));
      })
      .catch(function (err) {
        window.location.href = "/#/";
      });
  };
};

export const checkIfUsernameExists = function (
  username,
  company_id,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfUsernameExists + username + "/" + company_id)
      .then(function (response) {
        if (response && response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const checkIfUsernameExistsByGroupId = function (
  username,
  group_id,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfUsernameExistsByGroupId + username + "/" + group_id)
      .then(function (response) {
        if (response && response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const checkIfEmailExists = function (
  email,
  existsCallback,
  noExistsCallback,
) {
  return function (dispatch) {
    return axios
      .get(APIUrl.checkIfEmailExists + email)
      .then(function (response) {
        if (response.status === 200) {
          if (existsCallback) existsCallback();
        } else {
          if (noExistsCallback) noExistsCallback();
        }
      });
  };
};

export const createUser = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios
      .post(APIUrl.createUser, data)
      .then(function (response) {
        if (response) dispatch(getUser());
        return successCallback();
      })
      .catch(function (err) {
        console.log(err);
        return failureCallback();
      });
  };
};

export const updateUser = function (data, successCallback, failureCallback) {
  return function (dispatch) {
    return axios.post(APIUrl.updateUser, data).then(function (response) {
      dispatch(getUser());
      if (successCallback) successCallback();
    });
  };
};

// export const updateLang = function(lang) {
//   return function(dispatch) {
//     return axios
//       .get(APIUrl.updateLang + lang)
//       .then(function(response) {
//         // Refresh the user state
//         dispatch(getUser());
//       })
//       .catch(function(err) {
//         throw err;
//       });
//   };
// };

// export const checkIfUpdatedEmailExists = function(email, existsCallback, noExistsCallback){
//     return function(){
//         return axios.get(APIUrl.checkIfUpdatedEmailExists + email)
//             .then(function(response){
//                 if(response.status === 200) { if(existsCallback) existsCallback(); }
//                 else { if(noExistsCallback) noExistsCallback(); }
//             });
//     };
// };

// export const acceptCookies = function(successCallback){
//     return function(dispatch){
//         return axios.post(APIUrl.acceptCookies)
//             .then(function(response){
//                 successCallback();
//             });
//     };
// };

// export const addFavorite = function(data, successCallback){
//     // console.log("requete "+ data.updatedUser + " = "+data.updatedValue);
//     return function(dispatch){
//         return axios.post(APIUrl.addFavorite, data)
//             .then(function(response){
//                 dispatch(getUser());
//                 if(successCallback) successCallback();
//             });
//     };
// };

// export const deleteFavorite = function(data, successCallback){
//     // console.log("requetedelete "+ data.updatedUser + " = "+data.deletedValue);
//     return function(dispatch){
//         return axios.post(APIUrl.deleteFavorite, data)
//             .then(function(response){
//                 dispatch(getUser());
//                 if(successCallback) successCallback();
//             });
//     };
// };
